module.exports = __webpack_public_path__ + "713fad3d7a1ca6b9009159996ed3407c.fbx";